import styled from 'styled-components';

const EditableElement = styled.div`
  margin: 14px 0;
`;

export default EditableElement;
